import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { AwardDetailsPage, AwardsPage } from './pages'

const AwardsRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.AWARDS.link}
      permissions={[PERMISSIONS.METADATA_TREE.LIST]}
      component={AwardsPage}
    />
    <PermissionRoute
      exact
      path={APP_ROUTES.AWARD_DETAILS.link}
      permissions={[PERMISSIONS.METADATA_TREE.GET]}
      component={AwardDetailsPage}
    />
  </Switch>
)

export default AwardsRouter
